import { heroEquipment } from "../HeroEquipment";

export const ogry = {
  heroes: {
    "Łowca (ogr)": {
      id: 0,
      startingEquipment: ["Włócznia", "Harpun"],
      cost: 160,
      number: 1,
      equipmentList:
        heroEquipment["Zwiadowcza kompania z Królestw Ogrów"]["Bohaterowie"],
      type: "Bohater",
      stats: {
        Początkowa: [6, 5, 4, 4, 4, 3, 4, 2, 9],
        Maksymalna: [6, 6, 5, 5, 5, 5, 6, 5, 9],
      },
      rules: [
        "Bycza szarża",
        "Dowódca",
        "Duży cel",
        "Głód trzewi",
        "Przepastne trzewia",
        "Ranger",
        "Strach",
        "Światowiec",
        "Tempy",
        "Wielkolud",
        "Zabójca potworów",
        "Zwiadowca",
      ],
      exp: 20,
      skills: [0, 1, 3, 5],
    },
    "Ogniobrzuchy (ogr)": {
      id: 1,
      startingEquipment: ["Broń wielka"],
      cost: 150,
      number: 1,
      equipmentList:
        heroEquipment["Zwiadowcza kompania z Królestw Ogrów"].Ogniobrzuchy,
      type: "Bohater",
      stats: {
        Początkowa: [6, 4, 3, 4, 4, 3, 2, 2, 7],
        Maksymalna: [6, 6, 5, 5, 5, 5, 6, 5, 9],
      },
      rules: [
        "Bycza szarża",
        "Duży cel",
        "Głód trzewi",
        "Mag (Magia Ognistej Paszczy)",
        "Przepastne trzewia",
        "Strach",
        "Tempy",
        "Wielkolud",
      ],
      exp: 10,
      skills: [0, 3, 5],
    },
    "Rzeźnik (ogr)": {
      id: 2,
      startingEquipment: ["Topór bojowy/Nadziak", "Maczuga ogrów"],
      cost: 150,
      number: 1,
      equipmentList:
        heroEquipment["Zwiadowcza kompania z Królestw Ogrów"].Rzeźnik,
      type: "Bohater",
      stats: {
        Początkowa: [6, 4, 3, 4, 4, 3, 2, 2, 7],
        Maksymalna: [6, 6, 5, 5, 5, 5, 6, 5, 9],
      },
      rules: [
        "Bycza szarża",
        "Duchowny (Magia Jelit)",
        "Duży cel",
        "Głód trzewi",
        "Mocna głowa",
        "Modlitwa",
        "Przepastne trzewia",
        "Rozproszenie magii (2)",
        "Strach",
        "Tempy",
        "Wielkolud",
      ],
      exp: 10,
      skills: [0, 3, 5],
    },
    "Żelazobrzuchy (ogr)": {
      id: 3,
      startingEquipment: ["Broń wielka", "Hełm"],
      cost: 140,
      number: 1,
      equipmentList:
        heroEquipment["Zwiadowcza kompania z Królestw Ogrów"]["Bohaterowie"],
      type: "Bohater",
      stats: {
        Początkowa: [6, 3, 2, 4, 4, 3, 2, 2, 8],
        Maksymalna: [6, 6, 5, 5, 5, 5, 6, 5, 9],
      },
      rules: [
        "Bycza szarża",
        "Duży cel",
        "Głód trzewi",
        "Przepastne trzewia",
        "Strach",
        "Tempy",
        "Wielkolud",
      ],
      exp: 8,
      skills: [0, 3, 5],
    },
    "Traper (gnoblar)": {
      id: 4,
      startingEquipment: ["Sztylet", "Broń miotana (noże)"],
      cost: 25,
      number: 2,
      equipmentList:
        heroEquipment["Zwiadowcza kompania z Królestw Ogrów"].Gnoblar,
      type: "Bohater",
      stats: {
        Początkowa: [4, 2, 3, 2, 3, 1, 3, 1, 5],
        Maksymalna: [5, 5, 6, 3, 4, 3, 6, 4, 7],
      },
      rules: [
        "Dziwnie cuchnom",
        "Przyboczny",
        "Pułapkarz",
        "Ranger",
        "Rozmiar rzondzi",
        "Zwiadowca",
      ],
      exp: 0,
      skills: [0, 1, 4, 5],
    },
    "Zbrojny (Gnoblar)": {
      id: 5,
      startingEquipment: ["Sztylet"],
      cost: 15,
      number: 12,
      equipmentList:
        heroEquipment["Zwiadowcza kompania z Królestw Ogrów"].Gnoblar,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 2, 3, 2, 3, 1, 3, 1, 5],
        Maksymalna: [5, 5, 6, 3, 4, 3, 6, 4, 7],
      },
      rules: [
        "Animozja",
        "Dziwnie cuchnom",
        "Nieśmiertelny",
        "Rozmiar rzondzi",
        "Stan niższy",
      ],
    },
    "Byk (ogr)": {
      id: 5,
      startingEquipment: ["Maczuga ogrów"],
      cost: 140,
      number: 3,
      equipmentList:
        heroEquipment["Zwiadowcza kompania z Królestw Ogrów"]["Stronnicy"],
      type: "Stronnik",
      stats: {
        Początkowa: [6, 3, 2, 4, 4, 3, 2, 2, 7],
        Maksymalna: [6, 6, 5, 5, 5, 5, 6, 5, 9],
      },
      rules: [
        "Bycza szarża",
        "Chorążowie & sygnaliści",
        "Duży cel",
        "Głód trzewi",
        "Przepastne trzewia",
        "Strach",
        "Tempy",
        "Wielkolud",
      ],
    },
    Szablozębny: {
      id: 6,
      startingEquipment: ["Broń naturalna (precyzyjne uderzenie)"],
      cost: 70,
      number: 2,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [8, 4, 0, 4, 4, 2, 4, 2, 4],
        Maksymalna: [8, 4, 0, 4, 4, 2, 4, 2, 4],
      },
      rules: [
        "Duży cel",
        "Głód krwi",
        "Nienawiść",
        "Rączy",
        "Strach",
        "Zwiadowca",
        "Zwierzę",
      ],
    },
    Gorger: {
      id: 7,
      startingEquipment: ["Broń naturalna (przebicie pancerza)"],
      cost: 200,
      number: 1,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [6, 3, 0, 5, 4, 3, 2, 2, 8],
        Maksymalna: [6, 6, 0, 5, 5, 5, 6, 5, 8],
      },
      rules: [
        "Bycza szarża",
        "Duży cel",
        "Furia",
        "Głód krwi",
        "Głód trzewi",
        "Ograniczony",
        "Przepastne trzewia",
        "Ranger",
        "Stan niższy",
        "Strach",
        "Tempy",
        "Wielkolud",
        "Zabójczy cios",
        "Zwiadowca",
      ],
    },
    Yeti: {
      id: 8,
      startingEquipment: ["Broń naturalna (wspinaczka)"],
      cost: 175,
      number: 1,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [7, 3, 0, 5, 4, 3, 4, 2, 7],
        Maksymalna: [7, 6, 0, 5, 5, 5, 6, 5, 8],
      },
      rules: [
        "Bycza szarża",
        "Duży cel",
        "Głód trzewi",
        "Niepokojący",
        "Ograniczony",
        "Przepastne trzewia",
        "Stan niższy",
        "Strach",
        "Tempy",
        "Wielkolud",
      ],
    },
    Rydwan: {
      id: 9,
      startingEquipment: [],
      cost: 125,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Rydwan: ["-", "-", "-", 5, 5, 8, "-", "-", "-"],
        Nosorożnik: [6, 3, 0, 5, "-", "-", 2, 3, 4],
      },
      rules: ["Duży cel", "Machina wojenna", "Rydwan"],
    },
  },

  limit: 500,
  minModels: 3,
  maxModels: 12,
  name: "Zwiadowcza kompania z Królestw Ogrów",
  nature: "Zła",
  armyRules: ["Rozrzutność"],
  mercenaries: [
    "Czarownica",
    "Łowca nagród",
    "Rozbójnik",
    "Trefniś",
    "Złodziej",
    "Zwiadowca",
  ],
};
